/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createDevice = /* GraphQL */ `
  mutation CreateDevice(
    $input: CreateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    createDevice(input: $input, condition: $condition) {
      id
      deviceID
      image
      name
      location
      Room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      createdAt
      updatedAt
      deviceRoomId
      owner
    }
  }
`;
export const updateDevice = /* GraphQL */ `
  mutation UpdateDevice(
    $input: UpdateDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    updateDevice(input: $input, condition: $condition) {
      id
      deviceID
      image
      name
      location
      Room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      createdAt
      updatedAt
      deviceRoomId
      owner
    }
  }
`;
export const deleteDevice = /* GraphQL */ `
  mutation DeleteDevice(
    $input: DeleteDeviceInput!
    $condition: ModelDeviceConditionInput
  ) {
    deleteDevice(input: $input, condition: $condition) {
      id
      deviceID
      image
      name
      location
      Room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      createdAt
      updatedAt
      deviceRoomId
      owner
    }
  }
`;
export const createServiceCategory = /* GraphQL */ `
  mutation CreateServiceCategory(
    $input: CreateServiceCategoryInput!
    $condition: ModelServiceCategoryConditionInput
  ) {
    createServiceCategory(input: $input, condition: $condition) {
      id
      name
      description
      isActive
      products {
        items {
          id
          name
          price
          description
          perDay
          availible
          images
          isActive
          serviceCategoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      rooms {
        items {
          id
          roomID
          categoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateServiceCategory = /* GraphQL */ `
  mutation UpdateServiceCategory(
    $input: UpdateServiceCategoryInput!
    $condition: ModelServiceCategoryConditionInput
  ) {
    updateServiceCategory(input: $input, condition: $condition) {
      id
      name
      description
      isActive
      products {
        items {
          id
          name
          price
          description
          perDay
          availible
          images
          isActive
          serviceCategoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      rooms {
        items {
          id
          roomID
          categoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteServiceCategory = /* GraphQL */ `
  mutation DeleteServiceCategory(
    $input: DeleteServiceCategoryInput!
    $condition: ModelServiceCategoryConditionInput
  ) {
    deleteServiceCategory(input: $input, condition: $condition) {
      id
      name
      description
      isActive
      products {
        items {
          id
          name
          price
          description
          perDay
          availible
          images
          isActive
          serviceCategoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      rooms {
        items {
          id
          roomID
          categoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createServiceProduct = /* GraphQL */ `
  mutation CreateServiceProduct(
    $input: CreateServiceProductInput!
    $condition: ModelServiceProductConditionInput
  ) {
    createServiceProduct(input: $input, condition: $condition) {
      id
      name
      price
      description
      perDay
      availible
      images
      isActive
      serviceCategoryID
      serviceCategory {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      bookings {
        items {
          id
          startTime
          endTime
          lengthDays
          bookingID
          productID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateServiceProduct = /* GraphQL */ `
  mutation UpdateServiceProduct(
    $input: UpdateServiceProductInput!
    $condition: ModelServiceProductConditionInput
  ) {
    updateServiceProduct(input: $input, condition: $condition) {
      id
      name
      price
      description
      perDay
      availible
      images
      isActive
      serviceCategoryID
      serviceCategory {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      bookings {
        items {
          id
          startTime
          endTime
          lengthDays
          bookingID
          productID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteServiceProduct = /* GraphQL */ `
  mutation DeleteServiceProduct(
    $input: DeleteServiceProductInput!
    $condition: ModelServiceProductConditionInput
  ) {
    deleteServiceProduct(input: $input, condition: $condition) {
      id
      name
      price
      description
      perDay
      availible
      images
      isActive
      serviceCategoryID
      serviceCategory {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      bookings {
        items {
          id
          startTime
          endTime
          lengthDays
          bookingID
          productID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createBookingItem = /* GraphQL */ `
  mutation CreateBookingItem(
    $input: CreateBookingItemInput!
    $condition: ModelBookingItemConditionInput
  ) {
    createBookingItem(input: $input, condition: $condition) {
      id
      startTime
      endTime
      lengthDays
      bookingID
      productID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      product {
        id
        name
        price
        description
        perDay
        availible
        images
        isActive
        serviceCategoryID
        serviceCategory {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        bookings {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateBookingItem = /* GraphQL */ `
  mutation UpdateBookingItem(
    $input: UpdateBookingItemInput!
    $condition: ModelBookingItemConditionInput
  ) {
    updateBookingItem(input: $input, condition: $condition) {
      id
      startTime
      endTime
      lengthDays
      bookingID
      productID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      product {
        id
        name
        price
        description
        perDay
        availible
        images
        isActive
        serviceCategoryID
        serviceCategory {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        bookings {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteBookingItem = /* GraphQL */ `
  mutation DeleteBookingItem(
    $input: DeleteBookingItemInput!
    $condition: ModelBookingItemConditionInput
  ) {
    deleteBookingItem(input: $input, condition: $condition) {
      id
      startTime
      endTime
      lengthDays
      bookingID
      productID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      product {
        id
        name
        price
        description
        perDay
        availible
        images
        isActive
        serviceCategoryID
        serviceCategory {
          id
          name
          description
          isActive
          createdAt
          updatedAt
          owner
        }
        bookings {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createRoomCatalog = /* GraphQL */ `
  mutation CreateRoomCatalog(
    $input: CreateRoomCatalogInput!
    $condition: ModelRoomCatalogConditionInput
  ) {
    createRoomCatalog(input: $input, condition: $condition) {
      id
      roomID
      categoryID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      category {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateRoomCatalog = /* GraphQL */ `
  mutation UpdateRoomCatalog(
    $input: UpdateRoomCatalogInput!
    $condition: ModelRoomCatalogConditionInput
  ) {
    updateRoomCatalog(input: $input, condition: $condition) {
      id
      roomID
      categoryID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      category {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteRoomCatalog = /* GraphQL */ `
  mutation DeleteRoomCatalog(
    $input: DeleteRoomCatalogInput!
    $condition: ModelRoomCatalogConditionInput
  ) {
    deleteRoomCatalog(input: $input, condition: $condition) {
      id
      roomID
      categoryID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      category {
        id
        name
        description
        isActive
        products {
          nextToken
          startedAt
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createSecurityItem = /* GraphQL */ `
  mutation CreateSecurityItem(
    $input: CreateSecurityItemInput!
    $condition: ModelSecurityItemConditionInput
  ) {
    createSecurityItem(input: $input, condition: $condition) {
      id
      type
      isActive
      channels
      documents
      amount
      bookings {
        items {
          id
          status
          type
          signatures
          bookingID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      rooms {
        items {
          id
          roomID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateSecurityItem = /* GraphQL */ `
  mutation UpdateSecurityItem(
    $input: UpdateSecurityItemInput!
    $condition: ModelSecurityItemConditionInput
  ) {
    updateSecurityItem(input: $input, condition: $condition) {
      id
      type
      isActive
      channels
      documents
      amount
      bookings {
        items {
          id
          status
          type
          signatures
          bookingID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      rooms {
        items {
          id
          roomID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteSecurityItem = /* GraphQL */ `
  mutation DeleteSecurityItem(
    $input: DeleteSecurityItemInput!
    $condition: ModelSecurityItemConditionInput
  ) {
    deleteSecurityItem(input: $input, condition: $condition) {
      id
      type
      isActive
      channels
      documents
      amount
      bookings {
        items {
          id
          status
          type
          signatures
          bookingID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      rooms {
        items {
          id
          roomID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createRoomSecurityItem = /* GraphQL */ `
  mutation CreateRoomSecurityItem(
    $input: CreateRoomSecurityItemInput!
    $condition: ModelRoomSecurityItemConditionInput
  ) {
    createRoomSecurityItem(input: $input, condition: $condition) {
      id
      roomID
      securityItemID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      securityItem {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateRoomSecurityItem = /* GraphQL */ `
  mutation UpdateRoomSecurityItem(
    $input: UpdateRoomSecurityItemInput!
    $condition: ModelRoomSecurityItemConditionInput
  ) {
    updateRoomSecurityItem(input: $input, condition: $condition) {
      id
      roomID
      securityItemID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      securityItem {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteRoomSecurityItem = /* GraphQL */ `
  mutation DeleteRoomSecurityItem(
    $input: DeleteRoomSecurityItemInput!
    $condition: ModelRoomSecurityItemConditionInput
  ) {
    deleteRoomSecurityItem(input: $input, condition: $condition) {
      id
      roomID
      securityItemID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      securityItem {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createBookingSecurityItem = /* GraphQL */ `
  mutation CreateBookingSecurityItem(
    $input: CreateBookingSecurityItemInput!
    $condition: ModelBookingSecurityItemConditionInput
  ) {
    createBookingSecurityItem(input: $input, condition: $condition) {
      id
      status
      type
      signatures
      bookingID
      securityItemID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      securityItem {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateBookingSecurityItem = /* GraphQL */ `
  mutation UpdateBookingSecurityItem(
    $input: UpdateBookingSecurityItemInput!
    $condition: ModelBookingSecurityItemConditionInput
  ) {
    updateBookingSecurityItem(input: $input, condition: $condition) {
      id
      status
      isComplete
      isCompleteSignatures
      hasDeposit
      verificationId
      type
      signatures
      bookingID
      securityItemID
      securityItem {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteBookingSecurityItem = /* GraphQL */ `
  mutation DeleteBookingSecurityItem(
    $input: DeleteBookingSecurityItemInput!
    $condition: ModelBookingSecurityItemConditionInput
  ) {
    deleteBookingSecurityItem(input: $input, condition: $condition) {
      id
      status
      type
      signatures
      bookingID
      securityItemID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      securityItem {
        id
        type
        isActive
        channels
        documents
        amount
        bookings {
          nextToken
        }
        rooms {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createContactGroup = /* GraphQL */ `
  mutation CreateContactGroup(
    $input: CreateContactGroupInput!
    $condition: ModelContactGroupConditionInput
  ) {
    createContactGroup(input: $input, condition: $condition) {
      id
      name
      contacts
      upsells {
        items {
          id
          contactGroupID
          upsellID
          relationshipType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateContactGroup = /* GraphQL */ `
  mutation UpdateContactGroup(
    $input: UpdateContactGroupInput!
    $condition: ModelContactGroupConditionInput
  ) {
    updateContactGroup(input: $input, condition: $condition) {
      id
      name
      contacts
      upsells {
        items {
          id
          contactGroupID
          upsellID
          relationshipType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteContactGroup = /* GraphQL */ `
  mutation DeleteContactGroup(
    $input: DeleteContactGroupInput!
    $condition: ModelContactGroupConditionInput
  ) {
    deleteContactGroup(input: $input, condition: $condition) {
      id
      name
      contacts
      upsells {
        items {
          id
          contactGroupID
          upsellID
          relationshipType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUpsellContactGroup = /* GraphQL */ `
  mutation CreateUpsellContactGroup(
    $input: CreateUpsellContactGroupInput!
    $condition: ModelUpsellContactGroupConditionInput
  ) {
    createUpsellContactGroup(input: $input, condition: $condition) {
      id
      contactGroupID
      upsellID
      contactGroup {
        id
        name
        contacts
        upsells {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      relationshipType
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUpsellContactGroup = /* GraphQL */ `
  mutation UpdateUpsellContactGroup(
    $input: UpdateUpsellContactGroupInput!
    $condition: ModelUpsellContactGroupConditionInput
  ) {
    updateUpsellContactGroup(input: $input, condition: $condition) {
      id
      contactGroupID
      upsellID
      contactGroup {
        id
        name
        contacts
        upsells {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      relationshipType
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUpsellContactGroup = /* GraphQL */ `
  mutation DeleteUpsellContactGroup(
    $input: DeleteUpsellContactGroupInput!
    $condition: ModelUpsellContactGroupConditionInput
  ) {
    deleteUpsellContactGroup(input: $input, condition: $condition) {
      id
      contactGroupID
      upsellID
      contactGroup {
        id
        name
        contacts
        upsells {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      relationshipType
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUpsell = /* GraphQL */ `
  mutation CreateUpsell(
    $input: CreateUpsellInput!
    $condition: ModelUpsellConditionInput
  ) {
    createUpsell(input: $input, condition: $condition) {
      id
      name
      type
      price
      images
      description
      saleType
      isActive
      prodID
      bookings {
        items {
          id
          status
          payIntent
          payMethod
          bookingID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      rooms {
        items {
          id
          roomID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      contactGroups {
        items {
          id
          contactGroupID
          upsellID
          relationshipType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUpsell = /* GraphQL */ `
  mutation UpdateUpsell(
    $input: UpdateUpsellInput!
    $condition: ModelUpsellConditionInput
  ) {
    updateUpsell(input: $input, condition: $condition) {
      id
      name
      type
      price
      images
      description
      saleType
      isActive
      prodID
      bookings {
        items {
          id
          status
          payIntent
          payMethod
          bookingID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      rooms {
        items {
          id
          roomID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      contactGroups {
        items {
          id
          contactGroupID
          upsellID
          relationshipType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUpsell = /* GraphQL */ `
  mutation DeleteUpsell(
    $input: DeleteUpsellInput!
    $condition: ModelUpsellConditionInput
  ) {
    deleteUpsell(input: $input, condition: $condition) {
      id
      name
      type
      price
      images
      description
      saleType
      isActive
      prodID
      bookings {
        items {
          id
          status
          payIntent
          payMethod
          bookingID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      rooms {
        items {
          id
          roomID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      contactGroups {
        items {
          id
          contactGroupID
          upsellID
          relationshipType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createBooking = /* GraphQL */ `
  mutation CreateBooking(
    $input: CreateBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    createBooking(input: $input, condition: $condition) {
      id
      notes
      checkInDate
      status
      pmsBookingID
      reservationID
      superhogStatus
      checkOutDate
      guestID
      deviceID
      codeID
      upsells {
        items {
          id
          status
          payIntent
          payMethod
          bookingID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      products {
        items {
          id
          startTime
          endTime
          lengthDays
          bookingID
          productID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      triggerNotification
      message
      dateSchedule
      source
      code
      roomID
      securityItems {
        items {
          id
          status
          type
          signatures
          bookingID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateBooking = /* GraphQL */ `
  mutation UpdateBooking(
    $input: UpdateBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    updateBooking(input: $input, condition: $condition) {
      id
      notes
      checkInDate
      status
      pmsBookingID
      reservationID
      superhogStatus
      checkOutDate
      guestID
      deviceID
      codeID
      upsells {
        items {
          id
          status
          payIntent
          payMethod
          bookingID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      products {
        items {
          id
          startTime
          endTime
          lengthDays
          bookingID
          productID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      triggerNotification
      message
      dateSchedule
      source
      code
      roomID
      securityItems {
        items {
          id
          status
          type
          signatures
          bookingID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteBooking = /* GraphQL */ `
  mutation DeleteBooking(
    $input: DeleteBookingInput!
    $condition: ModelBookingConditionInput
  ) {
    deleteBooking(input: $input, condition: $condition) {
      id
      notes
      checkInDate
      status
      pmsBookingID
      reservationID
      superhogStatus
      checkOutDate
      guestID
      deviceID
      codeID
      upsells {
        items {
          id
          status
          payIntent
          payMethod
          bookingID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      products {
        items {
          id
          startTime
          endTime
          lengthDays
          bookingID
          productID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      triggerNotification
      message
      dateSchedule
      source
      code
      roomID
      securityItems {
        items {
          id
          status
          type
          signatures
          bookingID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createBookingUpsell = /* GraphQL */ `
  mutation CreateBookingUpsell(
    $input: CreateBookingUpsellInput!
    $condition: ModelBookingUpsellConditionInput
  ) {
    createBookingUpsell(input: $input, condition: $condition) {
      id
      status
      payIntent
      payMethod
      bookingID
      upsellID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateBookingUpsell = /* GraphQL */ `
  mutation UpdateBookingUpsell(
    $input: UpdateBookingUpsellInput!
    $condition: ModelBookingUpsellConditionInput
  ) {
    updateBookingUpsell(input: $input, condition: $condition) {
      id
      status
      payIntent
      payMethod
      bookingID
      upsellID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteBookingUpsell = /* GraphQL */ `
  mutation DeleteBookingUpsell(
    $input: DeleteBookingUpsellInput!
    $condition: ModelBookingUpsellConditionInput
  ) {
    deleteBookingUpsell(input: $input, condition: $condition) {
      id
      status
      payIntent
      payMethod
      bookingID
      upsellID
      booking {
        id
        notes
        checkInDate
        status
        pmsBookingID
        reservationID
        superhogStatus
        checkOutDate
        guestID
        deviceID
        codeID
        upsells {
          nextToken
          startedAt
        }
        products {
          nextToken
        }
        triggerNotification
        message
        dateSchedule
        source
        code
        roomID
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createGuest = /* GraphQL */ `
  mutation CreateGuest(
    $input: CreateGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    createGuest(input: $input, condition: $condition) {
      id
      name
      notes
      phone
      email
      Bookings {
        items {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateGuest = /* GraphQL */ `
  mutation UpdateGuest(
    $input: UpdateGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    updateGuest(input: $input, condition: $condition) {
      id
      name
      notes
      phone
      email
      Bookings {
        items {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteGuest = /* GraphQL */ `
  mutation DeleteGuest(
    $input: DeleteGuestInput!
    $condition: ModelGuestConditionInput
  ) {
    deleteGuest(input: $input, condition: $condition) {
      id
      name
      notes
      phone
      email
      Bookings {
        items {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createGuideCatalog = /* GraphQL */ `
  mutation CreateGuideCatalog(
    $input: CreateGuideCatalogInput!
    $condition: ModelGuideCatalogConditionInput
  ) {
    createGuideCatalog(input: $input, condition: $condition) {
      id
      name
      isActive
      guides {
        items {
          id
          title
          description
          images
          guideCatalogID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateGuideCatalog = /* GraphQL */ `
  mutation UpdateGuideCatalog(
    $input: UpdateGuideCatalogInput!
    $condition: ModelGuideCatalogConditionInput
  ) {
    updateGuideCatalog(input: $input, condition: $condition) {
      id
      name
      isActive
      guides {
        items {
          id
          title
          description
          images
          guideCatalogID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteGuideCatalog = /* GraphQL */ `
  mutation DeleteGuideCatalog(
    $input: DeleteGuideCatalogInput!
    $condition: ModelGuideCatalogConditionInput
  ) {
    deleteGuideCatalog(input: $input, condition: $condition) {
      id
      name
      isActive
      guides {
        items {
          id
          title
          description
          images
          guideCatalogID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createGuide = /* GraphQL */ `
  mutation CreateGuide(
    $input: CreateGuideInput!
    $condition: ModelGuideConditionInput
  ) {
    createGuide(input: $input, condition: $condition) {
      id
      title
      description
      images
      rooms {
        items {
          id
          guideId
          roomId
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      guideCatalogID
      guideCatalog {
        id
        name
        isActive
        guides {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateGuide = /* GraphQL */ `
  mutation UpdateGuide(
    $input: UpdateGuideInput!
    $condition: ModelGuideConditionInput
  ) {
    updateGuide(input: $input, condition: $condition) {
      id
      title
      description
      images
      rooms {
        items {
          id
          guideId
          roomId
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      guideCatalogID
      guideCatalog {
        id
        name
        isActive
        guides {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteGuide = /* GraphQL */ `
  mutation DeleteGuide(
    $input: DeleteGuideInput!
    $condition: ModelGuideConditionInput
  ) {
    deleteGuide(input: $input, condition: $condition) {
      id
      title
      description
      images
      rooms {
        items {
          id
          guideId
          roomId
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      guideCatalogID
      guideCatalog {
        id
        name
        isActive
        guides {
          nextToken
          startedAt
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createRoom = /* GraphQL */ `
  mutation CreateRoom(
    $input: CreateRoomInput!
    $condition: ModelRoomConditionInput
  ) {
    createRoom(input: $input, condition: $condition) {
      id
      name
      description
      address
      wifiName
      wifiPass
      pmsID
      superhogEnabled
      superhogChannels
      mountLinks
      viatorLink
      viatorID
      color
      checkInSchedule
      ciboLink
      images
      checkIn {
        description
        image
      }
      checkOut {
        description
        image
      }
      guides {
        items {
          id
          guideId
          roomId
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      checkInTime
      checkOutTime
      Bookings {
        items {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      Device {
        id
        deviceID
        image
        name
        location
        Room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        createdAt
        updatedAt
        deviceRoomId
        owner
      }
      upsells {
        items {
          id
          roomID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      catalogs {
        items {
          id
          roomID
          categoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      securityItems {
        items {
          id
          roomID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      roomDeviceId
      owner
    }
  }
`;
export const updateRoom = /* GraphQL */ `
  mutation UpdateRoom(
    $input: UpdateRoomInput!
    $condition: ModelRoomConditionInput
  ) {
    updateRoom(input: $input, condition: $condition) {
      id
      name
      description
      address
      wifiName
      wifiPass
      pmsID
      superhogEnabled
      superhogChannels
      mountLinks
      viatorLink
      viatorID
      color
      checkInSchedule
      ciboLink
      images
      checkIn {
        description
        image
      }
      checkOut {
        description
        image
      }
      guides {
        items {
          id
          guideId
          roomId
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      checkInTime
      checkOutTime
      Bookings {
        items {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      Device {
        id
        deviceID
        image
        name
        location
        Room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        createdAt
        updatedAt
        deviceRoomId
        owner
      }
      upsells {
        items {
          id
          roomID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      catalogs {
        items {
          id
          roomID
          categoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      securityItems {
        items {
          id
          roomID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      roomDeviceId
      owner
    }
  }
`;
export const deleteRoom = /* GraphQL */ `
  mutation DeleteRoom(
    $input: DeleteRoomInput!
    $condition: ModelRoomConditionInput
  ) {
    deleteRoom(input: $input, condition: $condition) {
      id
      name
      description
      address
      wifiName
      wifiPass
      pmsID
      superhogEnabled
      superhogChannels
      mountLinks
      viatorLink
      viatorID
      color
      checkInSchedule
      ciboLink
      images
      checkIn {
        description
        image
      }
      checkOut {
        description
        image
      }
      guides {
        items {
          id
          guideId
          roomId
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      checkInTime
      checkOutTime
      Bookings {
        items {
          id
          notes
          checkInDate
          status
          pmsBookingID
          reservationID
          superhogStatus
          checkOutDate
          guestID
          deviceID
          codeID
          triggerNotification
          message
          dateSchedule
          source
          code
          roomID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      Device {
        id
        deviceID
        image
        name
        location
        Room {
          id
          name
          description
          address
          wifiName
          wifiPass
          pmsID
          superhogEnabled
          superhogChannels
          mountLinks
          viatorLink
          viatorID
          color
          checkInSchedule
          ciboLink
          images
          checkInTime
          checkOutTime
          createdAt
          updatedAt
          roomDeviceId
          owner
        }
        createdAt
        updatedAt
        deviceRoomId
        owner
      }
      upsells {
        items {
          id
          roomID
          upsellID
          createdAt
          updatedAt
          owner
        }
        nextToken
        startedAt
      }
      catalogs {
        items {
          id
          roomID
          categoryID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      securityItems {
        items {
          id
          roomID
          securityItemID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      roomDeviceId
      owner
    }
  }
`;
export const createRoomUpsell = /* GraphQL */ `
  mutation CreateRoomUpsell(
    $input: CreateRoomUpsellInput!
    $condition: ModelRoomUpsellConditionInput
  ) {
    createRoomUpsell(input: $input, condition: $condition) {
      id
      roomID
      upsellID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateRoomUpsell = /* GraphQL */ `
  mutation UpdateRoomUpsell(
    $input: UpdateRoomUpsellInput!
    $condition: ModelRoomUpsellConditionInput
  ) {
    updateRoomUpsell(input: $input, condition: $condition) {
      id
      roomID
      upsellID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteRoomUpsell = /* GraphQL */ `
  mutation DeleteRoomUpsell(
    $input: DeleteRoomUpsellInput!
    $condition: ModelRoomUpsellConditionInput
  ) {
    deleteRoomUpsell(input: $input, condition: $condition) {
      id
      roomID
      upsellID
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      upsell {
        id
        name
        type
        price
        images
        description
        saleType
        isActive
        prodID
        bookings {
          nextToken
          startedAt
        }
        rooms {
          nextToken
          startedAt
        }
        contactGroups {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createProvider = /* GraphQL */ `
  mutation CreateProvider(
    $input: CreateProviderInput!
    $condition: ModelProviderConditionInput
  ) {
    createProvider(input: $input, condition: $condition) {
      id
      name
      website
      bio
      email
      phone
      subscribers
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateProvider = /* GraphQL */ `
  mutation UpdateProvider(
    $input: UpdateProviderInput!
    $condition: ModelProviderConditionInput
  ) {
    updateProvider(input: $input, condition: $condition) {
      id
      name
      website
      bio
      email
      phone
      subscribers
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteProvider = /* GraphQL */ `
  mutation DeleteProvider(
    $input: DeleteProviderInput!
    $condition: ModelProviderConditionInput
  ) {
    deleteProvider(input: $input, condition: $condition) {
      id
      name
      website
      bio
      email
      phone
      subscribers
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createGuideRoom = /* GraphQL */ `
  mutation CreateGuideRoom(
    $input: CreateGuideRoomInput!
    $condition: ModelGuideRoomConditionInput
  ) {
    createGuideRoom(input: $input, condition: $condition) {
      id
      guideId
      roomId
      guide {
        id
        title
        description
        images
        rooms {
          nextToken
          startedAt
        }
        guideCatalogID
        guideCatalog {
          id
          name
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateGuideRoom = /* GraphQL */ `
  mutation UpdateGuideRoom(
    $input: UpdateGuideRoomInput!
    $condition: ModelGuideRoomConditionInput
  ) {
    updateGuideRoom(input: $input, condition: $condition) {
      id
      guideId
      roomId
      guide {
        id
        title
        description
        images
        rooms {
          nextToken
          startedAt
        }
        guideCatalogID
        guideCatalog {
          id
          name
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteGuideRoom = /* GraphQL */ `
  mutation DeleteGuideRoom(
    $input: DeleteGuideRoomInput!
    $condition: ModelGuideRoomConditionInput
  ) {
    deleteGuideRoom(input: $input, condition: $condition) {
      id
      guideId
      roomId
      guide {
        id
        title
        description
        images
        rooms {
          nextToken
          startedAt
        }
        guideCatalogID
        guideCatalog {
          id
          name
          isActive
          createdAt
          updatedAt
          owner
        }
        createdAt
        updatedAt
        owner
      }
      room {
        id
        name
        description
        address
        wifiName
        wifiPass
        pmsID
        superhogEnabled
        superhogChannels
        mountLinks
        viatorLink
        viatorID
        color
        checkInSchedule
        ciboLink
        images
        checkIn {
          description
          image
        }
        checkOut {
          description
          image
        }
        guides {
          nextToken
          startedAt
        }
        checkInTime
        checkOutTime
        Bookings {
          nextToken
          startedAt
        }
        Device {
          id
          deviceID
          image
          name
          location
          createdAt
          updatedAt
          deviceRoomId
          owner
        }
        upsells {
          nextToken
          startedAt
        }
        catalogs {
          nextToken
        }
        securityItems {
          nextToken
        }
        createdAt
        updatedAt
        roomDeviceId
        owner
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUsers = /* GraphQL */ `
  mutation CreateUsers($input: CreateUsersInput!) {
    createUsers(input: $input) {
      users
      email
      password
      name
      images
      stripeId
      pmsLinkID
      pmsLinkStatus
      pmsConnectionID
      seamIds
      notificationSources
    }
  }
`;
export const updateUsers = /* GraphQL */ `
  mutation UpdateUsers($input: UpdateUsersInput!) {
    updateUsers(input: $input) {
      users
      email
      password
      name
      images
      stripeId
      pmsLinkID
      pmsLinkStatus
      pmsConnectionID
      seamIds
      notificationSources
    }
  }
`;
export const deleteUsers = /* GraphQL */ `
  mutation DeleteUsers($input: DeleteUsersInput!) {
    deleteUsers(input: $input) {
      users
      email
      password
      name
      images
      stripeId
      pmsLinkID
      pmsLinkStatus
      pmsConnectionID
      seamIds
      notificationSources
    }
  }
`;
